<template>
  <div class="p-10" v-if="emopsUf == 'AM'">
    <div class="w-full" v-if="id_segmento == 1">
      <div class="w-full back">
        <img src="./condominio-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 2">
      <div class="w-full back">
        <img src="./residencia-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 3">
      <div class="w-full back">
        <img src="./comercio-alimenticio-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 4">
      <div class="w-full back">
        <img src="./empresa-comercial-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 5">
      <div class="w-full back">
        <img src="./industria-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 6">
      <div class="w-full back">
      </div>
    </div>
    <div class="w-full" v-if="id_segmento == 7 && segmento == 'Restaurantes'">
      <div class="w-full back">
        <img src="./restaurante-1.png" />
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>    
  </div>
  <div class="p-10" v-else-if="emopsUf != 'AM'">
    <div class="w-full" v-if="id_segmento == 7 && segmento == 'Prestadores de Serviços'">
      <div class="w-full back">
        <!-- <img src="./restaurante-1.png" /> --> 
        <br><br><br><br><br><img src="./ECONTROL-VR.png"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id_segmento: 0,
    segmento: '',
    emopsUf: ''
  },
  mounted () {
  }
};
</script>

<style lang="scss">
.back {
  width: 100% !important;
  height: 100% !important;
}
</style>
